import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)`
  height: 100%;
  width: 100%;
  background-color: ${themeStyle.varBackgroundAlt};
`;

export const Header = styled(FlexColumn)`
  background-color: ${themeStyle.varBackgroundAlt};
  padding: 32px;
  gap: 8px;
  border-bottom: 1px solid ${themeStyle.varInkLight};
  border-radius: ${themeStyle.radiusLarge} ${themeStyle.radiusLarge} 0px 0px;
`;

export const DividerWithCenteredText = styled(FlexRow)`
  align-items: center;
  padding: 16px 0px;
  gap: 12px;
`;

export const Footer = styled(FlexColumn)<{ isMobile: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '0px 24px 24px' : '0px 32px 32px')};
  border-radius: ${({ isMobile }) =>
    !isMobile && `0px 0px ${themeStyle.radiusLarge} ${themeStyle.radiusLarge}`};

  background: ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.shadowMedium};
`;

export const Body = styled(FlexColumn)<{ isMobile: boolean }>`
  padding: ${({ isMobile }) => (isMobile ? '0px 16px 16px' : '16px 32px 32px')};
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
  min-height: 0;
`;
